/**
 * Inventory Info Provider
 * Replaces the functionality previously provided by the Kark Multi-Inventory app
 * Provides window.inventoryInfo object with location management API
 */

(function() {
  'use strict';
  
  console.log('[Inventory Info Provider] Initializing...');
  
  // Location data - matches the locations in header-location-selector.js
  var locationData = {
    "42639884424": {
      "id": "42639884424",
      "name": "Wilsonville Pet Supply",
      "address1": "8406 SW Main St. #200",
      "address2": "",
      "city": "Wilsonville",
      "province": "Oregon",
      "state": "Oregon",
      "zip": "97070",
      "postalCode": "97070",
      "country": "US",
      "phone": "+15036829812",
      "latitude": 45.302142,
      "longitude": -122.763612
    },
    "43460657288": {
      "id": "43460657288",
      "name": "Newberg Location (Critter Cabana)",
      "address1": "516 E First St",
      "address2": "",
      "city": "Newberg",
      "province": "Oregon",
      "state": "Oregon",
      "zip": "97132",
      "postalCode": "97132",
      "country": "US",
      "phone": "+15035372570",
      "latitude": 45.3000451,
      "longitude": -122.9741523
    },
    "83963379929": {
      "id": "83963379929",
      "name": "Salem Pet Supply (North)",
      "address1": "3185 Market St NE",
      "address2": "",
      "city": "Salem",
      "province": "Oregon",
      "state": "Oregon",
      "zip": "97301",
      "postalCode": "97301",
      "country": "US",
      "phone": "+15039907455",
      "latitude": 44.9511534,
      "longitude": -122.9964808
    },
    "83963445465": {
      "id": "83963445465",
      "name": "South Salem Pet Supply",
      "address1": "4695 Commercial St SE",
      "address2": "",
      "city": "Salem",
      "province": "Oregon",
      "state": "Oregon",
      "zip": "97302",
      "postalCode": "97302",
      "country": "US",
      "phone": "+15035850553",
      "latitude": 44.8867386,
      "longitude": -123.0345652
    },
    "85743730905": {
      "id": "85743730905",
      "name": "Gresham Pet Supply",
      "address1": "1152 Northwest Civic Drive",
      "address2": "",
      "city": "Gresham",
      "province": "Oregon",
      "state": "Oregon",
      "zip": "97030",
      "postalCode": "97030",
      "country": "US",
      "phone": "+15036661518",
      "latitude": 45.505471,
      "longitude": -122.4408056
    },
    "83963281625": {
      "id": "83963281625",
      "name": "Tigard Pet Supply",
      "address1": "16200 SW Pacific Hwy",
      "address2": "Suite W-W2",
      "city": "Tigard",
      "province": "Oregon",
      "state": "Oregon",
      "zip": "97223",
      "postalCode": "97223",
      "country": "US",
      "phone": "+15033392426",
      "latitude": 45.4030263,
      "longitude": -122.7946112
    }
  };
  
  // Online warehouse location ID (if you have one, otherwise use null)
  var onlineLocationId = null; // Set this if you have an online warehouse location
  
  // Get all location IDs
  var locationIds = Object.keys(locationData);
  
  // Convert location data to array format
  var locationsArray = locationIds.map(function(id) {
    return locationData[id];
  });
  
  // Selected location storage
  var selectedLocationId = null;
  
  // Load selected location from localStorage
  function loadSelectedLocation() {
    try {
      var saved = localStorage.getItem('selectedLocationId');
      if (saved) {
        selectedLocationId = saved;
        console.log('[Inventory Info Provider] Loaded selected location from localStorage:', selectedLocationId);
      }
    } catch(e) {
      console.warn('[Inventory Info Provider] Could not load from localStorage:', e);
    }
  }
  
  // Save selected location to localStorage
  function saveSelectedLocation(locationId) {
    try {
      localStorage.setItem('selectedLocationId', String(locationId));
      console.log('[Inventory Info Provider] Saved selected location to localStorage:', locationId);
    } catch(e) {
      console.warn('[Inventory Info Provider] Could not save to localStorage:', e);
    }
  }
  
  // Initialize selected location
  loadSelectedLocation();
  
  // Create inventoryInfo object
  window.inventoryInfo = {
    shop: {
      domain: window.Shopify?.shop || 'cascadepetsupply.myshopify.com'
    },
    pageType: 'product',
    settings: {
      onlineLocation: onlineLocationId,
      onlineLocationLabel: 'Online Warehouse',
      stockLocationRules: {
        inCountryRule: {
          locationPicker: 'modalPicker',
          showModalOnVisit: false,
          ignoreAtc: true
        }
      }
    },
    locationSettings: {
      details: locationsArray,
      locations: locationIds.map(function(id) {
        return { id: id };
      })
    },
    selectedLocation: selectedLocationId ? locationData[selectedLocationId] : null,
    api: {
      /**
       * Select a location
       * @param {string|number} locationId - The location ID to select
       * @returns {Promise} Resolves when location is selected
       */
      selectLocation: function(locationId) {
        return new Promise(function(resolve, reject) {
          var locIdStr = String(locationId);
          
          if (!locationData[locIdStr]) {
            console.warn('[Inventory Info Provider] Location not found:', locIdStr);
            reject(new Error('Location not found: ' + locIdStr));
            return;
          }
          
          selectedLocationId = locIdStr;
          window.inventoryInfo.selectedLocation = locationData[locIdStr];
          saveSelectedLocation(selectedLocationId);
          
          console.log('[Inventory Info Provider] Location selected:', locIdStr, locationData[locIdStr].name);
          
          // Update cart with selected location (Shopify cart API)
          if (window.Shopify && window.Shopify.cart) {
            // Update cart attributes if needed
            var attributes = {
              'selected_location_id': locIdStr,
              'selected_location_name': locationData[locIdStr].name
            };
            
            // Use fetch to update cart
            fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                attributes: attributes
              })
            }).then(function(response) {
              return response.json();
            }).then(function(cart) {
              console.log('[Inventory Info Provider] Cart updated with location');
              resolve(locationData[locIdStr]);
            }).catch(function(error) {
              console.warn('[Inventory Info Provider] Cart update failed, but location selected:', error);
              // Still resolve because location selection succeeded
              resolve(locationData[locIdStr]);
            });
          } else {
            // Resolve immediately if cart API not available
            resolve(locationData[locIdStr]);
          }
          
          // Trigger custom event for location change
          var event = new CustomEvent('locationChanged', {
            detail: {
              locationId: locIdStr,
              location: locationData[locIdStr]
            }
          });
          document.dispatchEvent(event);
          
          // Also trigger inventoryInfo:locationChanged
          var event2 = new CustomEvent('inventoryInfo:locationChanged', {
            detail: {
              locationId: locIdStr,
              location: locationData[locIdStr]
            }
          });
          document.dispatchEvent(event2);
        });
      },
      
      /**
       * Get the currently selected location ID
       * @returns {string|number|null} The selected location ID
       */
      getSelectedLocationId: function() {
        return selectedLocationId;
      },
      
      /**
       * Get the currently selected location info
       * @param {string|number} locationId - Optional location ID, defaults to selected
       * @returns {object|null} Location info or null
       */
      getSelectedLocationInfo: function(locationId) {
        var locId = locationId || selectedLocationId;
        if (!locId) return null;
        
        var locIdStr = String(locId);
        var location = locationData[locIdStr];
        
        if (!location) return null;
        
        // Return HTML string similar to what Kark app would return
        return '<div class="iia-select-location-info iia-selected-location-container">' +
               '<span class="iia-icon iia-selected-store-icon"></span>' +
               '<span class="iia-selected-location-text">Your selected location</span>' +
               '<a class="iia-change-location" href="javascript:void(0)">Change</a>' +
               '</div>';
      },
      
      /**
       * Get the currently selected location (async)
       * @returns {Promise} Resolves with location object
       */
      getSelectedLocation: function() {
        return new Promise(function(resolve) {
          if (selectedLocationId && locationData[selectedLocationId]) {
            resolve(locationData[selectedLocationId]);
          } else {
            resolve(null);
          }
        });
      },
      
      /**
       * Show location picker (delegated to header-location-selector.js)
       */
      showLocationPicker: function() {
        // This will be hooked by header-location-selector.js
        console.log('[Inventory Info Provider] showLocationPicker called - should be handled by header-location-selector.js');
      }
    }
  };
  
  console.log('[Inventory Info Provider] window.inventoryInfo initialized with', locationsArray.length, 'locations');
  console.log('[Inventory Info Provider] Selected location:', selectedLocationId);
  
  // Make sure it's available immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('[Inventory Info Provider] DOM loaded, inventoryInfo ready');
    });
  } else {
    console.log('[Inventory Info Provider] DOM already loaded, inventoryInfo ready');
  }
})();

